const API_BASE_URL = 'https://care-api.equily.ng';

/**
 * Fetch public landing page stats (no auth required).
 * Expected response: { data: { flws: number, courses: number, enrollments: number } }
 */
export async function fetchLandingStats(signal) {
  const res = await fetch(`${API_BASE_URL}/api/public/stats`, { signal });
  if (!res.ok) throw new Error('Failed to fetch landing stats');
  return res.json();
}

/**
 * Fetch public list of courses for the landing page (no auth required).
 * Expected response: { data: [{ id, title, category, modules_count, duration_hours, students_count, rating, thumbnail_url }] }
 */
export async function fetchPublicCourses(signal) {
  const res = await fetch(`${API_BASE_URL}/api/public/courses`, { signal });
  if (!res.ok) throw new Error('Failed to fetch courses');
  return res.json();
}

/**
 * Fetch public enrollment count (no auth required).
 * Expected response: { data: { total: number } }
 */
export async function fetchPublicEnrollments(signal) {
  const res = await fetch(`${API_BASE_URL}/api/public/enrollments`, { signal });
  if (!res.ok) throw new Error('Failed to fetch enrollments');
  return res.json();
}
